module.exports = __webpack_public_path__ + "static/media/pujaIcon.d7a2ad54.jpg";